import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconClapboard"><Path d="M21 18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V9.5H21V18.25Z" fill="currentColor"/><Path d="M7.20898 8H3V5.75C3 4.23122 4.23122 3 5.75 3H8.87598L7.20898 8Z" fill="currentColor"/><Path d="M13.459 8H8.79102L10.458 3H15.126L13.459 8Z" fill="currentColor"/><Path d="M18.25 3C19.7688 3 21 4.23122 21 5.75V8H15.041L16.708 3H18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboard;
